@use 'vars';

.action-sheet {
  position: fixed;
  inset: auto 0 0 0;
  z-index: vars.$z-index-above-modal;
  background: vars.$white;
  border-radius: vars.$border-radius-large vars.$border-radius-large 0 0;
  padding: vars.$padding-medium;

  &-backdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: vars.$z-index-above-modal;
  }
}
